import { motion } from "framer-motion";
import { Check, Star } from "lucide-react";
import { PACKAGES } from "@/data/content";

export const Pricing = () => {
  return (
    <section id="pricing" data-testid="pricing-section" className="relative py-24 sm:py-32 border-t border-line">
      <div className="container-x">
        <div className="max-w-2xl mb-16">
          <span className="mono-label text-accent">[ Packages ]</span>
          <h2 className="font-head font-black tracking-tighter text-4xl sm:text-5xl lg:text-6xl mt-4 text-balance">
            Simple, honest pricing.
          </h2>
          <p className="text-text-2 mt-4">
            Transparent packages built for local budgets. Every plan is customizable — let's talk.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {PACKAGES.map((pkg, i) => (
            <motion.div
              key={pkg.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              data-testid={`pricing-card-${pkg.name.toLowerCase()}`}
              className={`relative p-8 lg:p-10 border flex flex-col ${
                pkg.highlight ? "bg-surface-2 border-accent" : "bg-surface border-line"
              }`}
            >
              {pkg.highlight && (
                <div className="absolute -top-3 left-8 bg-accent text-ink mono-label px-3 py-1 flex items-center gap-1">
                  <Star className="w-3 h-3 fill-ink" /> {pkg.tag}
                </div>
              )}
              {!pkg.highlight && <span className="mono-label text-text-2">{pkg.tag}</span>}

              <h3 className="font-head font-bold text-2xl mt-3">{pkg.name}</h3>
              <div className="mt-4 flex items-end gap-2">
                <span className="font-head font-black text-5xl">{pkg.price}</span>
                {pkg.price !== "Custom" && <span className="text-text-2 mb-1.5 text-sm">starting</span>}
              </div>
              <p className="text-text-2 text-sm mt-4 leading-relaxed">{pkg.desc}</p>

              <ul className="mt-8 space-y-3 flex-1">
                {pkg.features.map((f) => (
                  <li key={f} className="flex items-start gap-3 text-sm">
                    <Check className="w-4 h-4 text-accent mt-0.5 shrink-0" />
                    <span className="text-white/85">{f}</span>
                  </li>
                ))}
              </ul>

              <a
                href="#contact"
                data-testid={`pricing-cta-${pkg.name.toLowerCase()}`}
                className={`mt-10 inline-flex items-center justify-center font-head font-bold py-3.5 transition-colors ${
                  pkg.highlight
                    ? "bg-accent text-ink hover:bg-white"
                    : "border border-line text-white hover:border-accent hover:text-accent"
                }`}
              >
                Get started
              </a>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
